/**
 * **체류 측정(`page_engaged`)의 범위와 박자** — 바꾸면 그 뒤 행부터 적용된다.
 */

import type { AnalyticsPage } from 'src/types/analytics/events';

/** 체류·스크롤을 재는 화면 — 광고·외부 링크가 닿는 마케팅 사이트 */
export const ENGAGEMENT_PAGES: readonly AnalyticsPage[] = ['marketing-site', 'home-landing'];

/** 보이는 상태로 머문 시간이 이 값을 넘을 때마다 누적값 한 줄(앱 내 브라우저는 떠날 때 신호가 안 올 수 있다) */
export const ENGAGEMENT_HEARTBEAT_MS: readonly number[] = [10_000, 30_000, 60_000, 120_000, 300_000, 600_000];

/** 「그 구역까지 봤다」의 기준 — 구역 윗변이 화면 높이의 이 비율 위로 올라왔다 */
export const ENGAGEMENT_SECTION_LINE = 0.5;
